export const NE_EI = {
  email: 'test@email.com',
};
